import { Card } from '@app/components/common/Card/Card';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { TranslationTable } from '@app/components/tables/TranslationTable/TranslationTable';
import { Col, Row } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

const TranslationPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle>{t('menu.translations')}</PageTitle>
      <Row gutter={[30, 30]}>
        <Col span={24}>
          <Card id="step-form" title={t('menu.translations')} padding="1.25rem">
            <TranslationTable />
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default TranslationPage;
